<template>
  <a-modal
    v-bind="attrs"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    :centered="true"
    :title="store.moveFolderData?.modalType === 'copy' ? '复制到' : '移动到'"
    okText="确认"
    :zIndex="1007"
  >
    <a-input-search
      v-model:value="searchValue"
      placeholder="文件夹"
      style="width: 100%"
      class="mt-20"
      @search="onSearch"
      @change="inputChange"
    />
    <div class="scroll mt-10" v-if="isSearch">
      <loadMore
        url="/aigcDam/aigc-folder/getAigcFolderDetailPageList"
        @updateList="updateList"
        :search-data="{
          name: searchValue
        }"
        :search-params="{
          perModuleType: '1',
          perFolderId: store.moveFolderData?.id
        }"
        height="300px"
      >
        <div
          class="mb-2 cursor-p padding-4"
          v-for="i in dataList"
          :key="i.id"
          @click="clickItem(i)"
          :class="{
            bg: i.id === select[0]
          }"
        >
          <div class="flex-s">
            <component :is="icons[i.icon]" class="fs-14 mr-6"></component>
            <div class="show1Row">
              {{ i.name }}
            </div>
          </div>
        </div>
      </loadMore>
    </div>
    <div v-else>
      <div class="mt-10 mb-10">文件夹（{{ data.length }}）</div>
      <div class="scroll mt-10">
        <tree
          v-model:selectList="select"
          @loadData="loadData"
          :data="data"
          :key="time"
          :options="options"
        >
          <template #item="{ item }">
            <component :is="icons[item.icon]" class="fs-14 mr-6"></component>
            <span v-if="!item?.isEdit">{{ item.name }}</span>
            <a-input
              v-else
              v-model:value="editInfo.name"
              size="small"
              class="wd80"
              @blur="saveEdit(item)"
              @click.stop
            />
          </template>
          <template #optionItem="{ item }">
            {{ item.fileNum }}
          </template>
        </tree>
      </div>
    </div>
  </a-modal>
</template>

<script setup>
import {
  Modal as AModal,
  InputSearch as AInputSearch,
  Input as AInput,
  message
} from 'ant-design-vue'
import { ref, useAttrs, watch } from 'vue'
import { aigcStore } from '@/store/aigcStore'
import tree from '@/components/tree.vue'
import * as icons from '@ant-design/icons-vue'
import {
  moveFolder,
  copyFolder,
  queryFolderList,
  editFolder,
  queryFolderPermissions
} from '@/service/api/aiDam'
import eventsBus from '@/utils/eventsBus'
import { cloneDeep } from 'lodash'
import loadMore from '@/components/paginationQuery/loadMore.vue'

const emits = defineEmits(['asyncSuccess'])

const store = aigcStore()
const attrs = useAttrs()
const confirmLoading = ref(false)
const select = ref([])
const searchValue = ref('')
const time = ref('1')
const editInfo = ref(null)
const isSearch = ref(false)
const dataList = ref([])
const data = ref([])
const options = ref([
  {
    text: '重命名',
    fnClick: (res) => {
      res.isEdit = true
      editInfo.value = cloneDeep(res)
    }
  },

  {
    text: '删除文件夹',
    fnClick: (res) => {
      store.openDeleteFolderModal(res)
    },
    style: {
      color: 'red'
    }
  }
])
const saveEdit = (i) => {
  editFolder(
    {
      ...editInfo.value
    },
    editInfo.value.id
  ).then((res) => {
    if (res.data) {
      message.success('编辑成功')
      eventsBus.emit('moveFolder')
      i.name = editInfo.value.name
    }
    i.isEdit = false
  })
}
const loadData = (treeNode, cb) => {
  queryFolderList({ parentId: treeNode.id }, treeNode.id).then((res) => {
    if (res?.data) {
      cb && cb(res.data)
    } else {
      cb && cb([])
    }
  })
}
const updateList = (list) => {
  dataList.value = list
}
const onSearch = () => {
  console.log('onSearch')
  isSearch.value = !!searchValue.value.length
  select.value = []
  time.value = Date.now()
}
const inputChange = () => {
  if (!searchValue.value.length) {
    onSearch()
  }
}
const clickItem = (i) => {
  select.value[0] = i.id
}
const handleOk = async () => {
  if (select.value.length == 0) return message.error('请选择数据')
  let res = null
  if (store.moveFolderData.id) {
    res = await queryFolderPermissions(
      {
        folderId: store.moveFolderData.id || '',
        moduleType: '1'
      },
      store.moveFolderData.id || ''
    )
  }

  if ((res?.data && res?.data?.permission.split(',').includes('4')) || !store.moveFolderData.id) {
    if (store.moveFolderData?.modalType === 'copy') {
      copyFolder(
        {
          folderId: store.moveFolderData.id || '',
          folderIdList: store.moveFolderData?.folderIdList || [],
          fileIdList: store.moveFolderData?.fileIdList || [],
          copyType: 1,
          targetFolderId: select.value[0]
        },
        select.value[0]
      ).then((res) => {
        if (res.data) {
          message.success('复制成功')
          emits('asyncSuccess', select.value)
          eventsBus.emit('moveFolder')
        }
        confirmLoading.value = false
      })
    } else {
      moveFolder(
        {
          folderId: store.moveFolderData.id || '',
          folderIdList: store.moveFolderData?.folderIdList || [],
          fileIdList: store.moveFolderData?.fileIdList || [],
          copyType: 1,
          targetFolderId: select.value[0]
        },
        select.value[0]
      ).then((res) => {
        if (res.data) {
          message.success('移动成功')
          emits('asyncSuccess', select.value)
          eventsBus.emit('moveFolder')
        }
        confirmLoading.value = false
      })
    }
  } else {
    message.error('您暂无操作权限')
  }
}
const getFolderList = () => {
  queryFolderList({ parentId: '0' }, '0').then((res) => {
    time.value = Date.now()
    if (res?.data) {
      data.value = res.data || []
    }
  })
}
watch(
  () => attrs.open,
  (val) => {
    confirmLoading.value = false
    if (val) {
      searchValue.value = ''
      onSearch()
      getFolderList()
    }
  }
)
eventsBus.on('deleteFolder', () => {
  getFolderList()
})
</script>

<style lang="less" scoped>
.scroll {
  width: 100%;
  height: 300px;
  overflow-y: auto;
  // border: 1px solid #ccc;
  // padding: 10px;
  border-radius: 6px;
}
.count {
  width: 40px;
  margin-left: 10px;
  display: block;
  text-align: right;
}
.menu {
  width: 60px;
  margin-left: 10px;
  display: none;
  text-align: right;
  cursor: pointer;
}
.bg {
  background: #f2f4ff;
}
.item:hover {
  .count {
    display: none;
  }
  .menu {
    display: block;
  }
}
.handle {
  cursor: move;
}
</style>
